// extracted by mini-css-extract-plugin
module.exports = {"painel":"style_painel__OMuuy","divider":"style_divider__2pJcn","profile":"style_profile__9slUc","player":"style_player__3bcWj"};